import React from 'react';
import Stack from '../../../v2BaseComponents/Stack';
import Loader from '../../../v2BaseComponents/Loader/Loader';

export type SelectLoaderOwnProps = {};

export type SelectLoaderProps = SelectLoaderOwnProps;

const SelectLoader: React.FC<SelectLoaderProps> = () => {
    return (
        <Stack horizontal justify="center" fullWidth padding={4}>
            <Loader size="sm" />
        </Stack>
    );
};

export default React.memo(SelectLoader);
